import { BaseBillingEntity } from '/@/modules/billing/models/BaseBillingEntity';
import { BillingAddon } from '/@/modules/billing/models/BillingAddon';
import { BillingCoupon } from '/@/modules/billing/models/BillingCoupon';
import { BillingPlan } from '/@/modules/billing/models/BillingPlan';

export class BillingSubscription extends BaseBillingEntity {
  /**
   * @var {BillingAddon[]}
   */
  addons;

  /**
   * @var {BillingCoupon[]}
   */
  coupons;

  /**
   * @var {number}
   */
  activatedAt;

  /**
   * @var {number}
   */
  billingPeriod;

  /**
   * @var {string}
   */
  billingPeriodUnit;

  /**
   * @var {number}
   */
  createdAt;

  /**
   * @var {string}
   */
  currencyCode;

  /**
   * @var {number}
   */
  currentTermEnd;

  /**
   * @var {number}
   */
  currentTermStart;

  /**
   * @var {string}
   */
  customerId;

  /**
   * @var {number}
   */
  dueInvoicesCount;

  /**
   * @var {boolean}
   */
  hasScheduledChanges;

  /**
   * @var {string}
   */
  id;

  /**
   * @var {number}
   */
  mrr;

  /**
   * @var {number}
   */
  nextBillingAt;

  /**
   * @var {string}
   */
  object;

  /**
   * @var {BillingPlan}
   */
  plan;

  /**
   * @var {number}
   */
  planAmount;

  /**
   * @var {number}
   */
  planFreeQuantity;

  /**
   * @var {string}
   */
  planId;

  /**
   * @var {number}
   */
  planQuantity;

  /**
   * @var {number}
   */
  planUnitPrice;

  /**
   * @var {string}
   */
  status;

  /**
   * @var {number}
   */
  startedAt;

  constructor(model = {}) {
    super();

    this.addons = BillingAddon.mapModels(model.addons);
    this.coupons = BillingCoupon.mapModels(model.coupons);
    this.activatedAt = model.activatedAt;
    this.billingPeriod = model.billingPeriod;
    this.billingPeriodUnit = model.billingPeriodUnit;
    this.createdAt = model.createdAt;
    this.currencyCode = model.currencyCode;
    this.currentTermEnd = model.currentTermEnd;
    this.currentTermStart = model.currentTermStart;
    this.customerId = model.customerId;
    this.dueInvoicesCount = model.dueInvoicesCount;
    this.hasScheduledChanges = model.hasScheduledChanges;
    this.id = model.id;
    this.mrr = model.mrr;
    this.nextBillingAt = model.nextBillingAt;
    this.object = model.object;
    this.plan = BillingPlan.mapModel(model.plan);
    this.planAmount = model.planAmount;
    this.planFreeQuantity = model.planFreeQuantity;
    this.planId = model.planId;
    this.planQuantity = model.planQuantity;
    this.planUnitPrice = model.planUnitPrice;
    this.status = model.status;
    this.startedAt = model.startedAt;
  }
}
